import * as React from 'react';
import { pipe } from 'fp-ts/lib/function';
import * as A from 'fp-ts/lib/Array';
import * as O from 'fp-ts/lib/Option';
import { useIORef } from '../../core/hooks';
import { useEffect, plugin, useSetter, useGetter } from './slots';

export const BOTTOM_CURSOR = -1;

export const reset = () => -1;

const inc = (x: number) => x + 1;
const dec = (x: number) => x - 1;

const topped = (inc: (x: number) => number) => (top: number) => (x: number) => Math.min(inc(x), top);
const botted = (dec: (x: number) => number) => (bottom: number) => (x: number) => Math.max(dec(x), bottom);

export const incTopped = topped(inc);
export const decBotted = botted(dec);

export const Plugin = plugin('cursor', null)(() => {

    const [, run] =         useEffect('cursorMove');

    const dropdownTarget =  useGetter('dropdownTarget');
    const target =          useGetter('target');
    const [changeValue] =   useEffect('changeValue');


    const startValue = React.useMemo(() => {
        const value = target.getValue();
        const data = dropdownTarget.getMutableData();
        return pipe(
            value,
            O.fromNullable,
            O.chain((value) => pipe(
                data,
                A.findIndex(d => d.id === value.id),
            )),
            O.fold(
                () => BOTTOM_CURSOR,
                (n) => n,
            ),
        );
    }, [changeValue])

    
    const { 
        read: get, 
        write: _set, 
        modify: _modify,
    } = useIORef(startValue);


    const set = run((x: number) => {
        _set(x)();
    });

    const modify = run((f: (x: number) => number) => {
        _modify(f)();
    });

    React.useEffect(() => {
        set(startValue);
    }, [startValue]);
    
    useSetter('cursor', {
        get,
        set,
        modify,
    });

    return null;
});
